import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';

import { getOrderInfos, updateState } from '@/redux/actions/goods/index';

import { stepEnumKey } from '../help';

import BuyGoodsList from './BuyGoodsList';
import SaleType from './SaleType';

import styles from './index.module.scss';

interface ISettleGoods {
  step: stepEnumKey;
  orderNo: string;
  name: string;
  certNo: string;
  roomNo: string;
  resvNo: string;
  roomStatus: number | null;

  paymentTypes: 0 | 1;
  payRadioChange: (paymentTypes: 0 | 1) => void;

  settleGoodsList: Array<Object>;
  settleLoading: boolean;
  settleTotalActualPrice: number;
  actualPay: number;
  settleTotalCount: number;

  getOrderInfos: (orderNo: string) => void;

  payModalRef: any;
  setPayType: () => void;
  selectPayType: (type: any) => void;
  payResultCallback: (payResult: Object) => void;
  onConfirmOk: () => void;
}

const Index = ($$: ISettleGoods) => {
  if ($$.step !== stepEnumKey.second) return null;

  // 商品总额信息
  const goodTotalInfo = {
    settleTotalActualPrice: $$.settleTotalActualPrice,
    settleTotalCount: $$.settleTotalCount,
    actualPay: $$.actualPay,
  };

  // mounted
  useEffect(() => {
    $$.getOrderInfos($$.orderNo);
  }, []);

  return (
    <Spin spinning={$$.settleLoading}>
      <section
        className={styles.container}
        // style={{ display: $$.step !== stepEnumKey.second ? 'none' : 'block' }}
      >
        <BuyGoodsList
          orderNo={$$.orderNo}
          list={$$.settleGoodsList}
          goodTotalInfo={goodTotalInfo}
          getOrderInfos={$$.getOrderInfos}
        />
        <SaleType paymentTypes={$$.paymentTypes} payRadioChange={$$.payRadioChange} {...$$} />
      </section>
    </Spin>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state.goods,
  };
};

export default connect(mapStateToProps, {
  getOrderInfos,
  updateState,
})(React.memo(Index));
